/*
Sample code:

<div class="module-marquee" data-speed="220" data-direction="left">
	<ul class="module-marquee__track">
		<li class="module-marquee__item"><img src="https://placehold.co/300x200" alt=""></li>
		<li class="module-marquee__item"><img src="https://placehold.co/250x240" alt=""></li>
		<li class="module-marquee__item"><img src="https://placehold.co/280x180" alt=""></li>
		<li class="module-marquee__item"><img src="https://placehold.co/300x220" alt=""></li>
	</ul>
</div>
 */

initAllMarquees();

function initAllMarquees() {
	const marquees = Array.from(document.querySelectorAll(".module-marquee"));

	// store rebuild functions directly
	const rebuilds = marquees.map(initMarquee);

	// global resize -> rebuild all (debounced)
	let t;
	window.addEventListener("resize", () => {
		clearTimeout(t);
		t = setTimeout(() => rebuilds.forEach(rebuildFn => rebuildFn()), 180);
	});
}

/* Initialize one marquee element and return its rebuild() function */
function initMarquee(marqueeEl) {
	const rawTrack = marqueeEl.querySelector(".module-marquee__track");

	if (!rawTrack)
	{
		console.warn("Marquee: no .module-marquee__track found", marqueeEl);
		return () => {
		}; // return empty rebuild
	}

	const speed     = Math.max(1, Number(marqueeEl.dataset.speed || 100));
	const direction = (marqueeEl.dataset.direction || "left").toLowerCase();

	// Normalize DOM to: <div.module-marquee__track><ul.module-marquee__group>...</ul></div>
	const {trackEl, baseGroupHTML} = normalizeTrack(rawTrack);
	const originalHTML             = baseGroupHTML;

	// initial build after images in the base group load
	waitForImages(trackEl).then(() => rebuild());

	// return the rebuild function directly
	return rebuild;

	/* Main rebuild routine */
	function rebuild() {
		// reset
		trackEl.classList.remove("running");
		trackEl.style.transform = "";
		trackEl.style.removeProperty("--marquee-start");
		trackEl.style.removeProperty("--marquee-end");
		trackEl.style.removeProperty("--marquee-duration");

		// restore single base group
		trackEl.innerHTML = originalHTML;

		const firstGroup = trackEl.querySelector(".module-marquee__group");

		if (!firstGroup)
		{
			return;
		}

		waitForImages(firstGroup).then(() => {
			const containerW = marqueeEl.clientWidth || marqueeEl.offsetWidth;
			const groupW     = Math.ceil(firstGroup.getBoundingClientRect().width);

			// gap reading (supports both gap and column-gap)
			const cs  = getComputedStyle(trackEl);
			const gap = parseFloat(cs.getPropertyValue("gap") || cs.getPropertyValue("column-gap") || "0") || 0;

			// distance per loop must include the gap
			const distance    = Math.max(1, Math.round(groupW + gap));
			const distanceNeg = -distance;

			// how many groups to cover viewport + 1 for seamless loop
			const needed = Math.max(2, Math.ceil(containerW / distance) + 1);

			for (let i = 1; i < needed; i++) trackEl.insertAdjacentHTML("beforeend", originalHTML);

			// duration so px/sec stays constant
			const durationSec = distance / speed;

			// set vars on the animated element (trackEl) — keyframes read these
			if (direction === "left")
			{
				trackEl.style.setProperty("--marquee-start", `0px`);
				trackEl.style.setProperty("--marquee-end", `${distanceNeg}px`);
			}
			else
			{
				trackEl.style.setProperty("--marquee-start", `${distanceNeg}px`);
				trackEl.style.setProperty("--marquee-end", `0px`);
			}

			trackEl.style.setProperty("--marquee-duration", `${durationSec}s`);
			trackEl.style.setProperty("--marquee-distance", `${distance}px`);

			// dynamic height: tallest item in the first group
			const items     = Array.from(firstGroup.querySelectorAll(".module-marquee__item, li"));
			const maxH      = items.reduce((m, it) => {
				const h = it.getBoundingClientRect().height || 0;
				return h > m ? h : m;
			}, 0);
			const mCS       = getComputedStyle(marqueeEl);
			const padTop    = parseFloat(mCS.paddingTop) || 0;
			const padBottom = parseFloat(mCS.paddingBottom) || 0;

			marqueeEl.style.height = Math.ceil(maxH + padTop + padBottom) + "px";

			// set starting transform so there's no flash
			trackEl.style.transform = `translateX(${direction === "left" ? 0 : distanceNeg}px)`;

			// start animation on next frame so vars take effect
			requestAnimationFrame(() => trackEl.classList.add("running"));
		});
	}
}

/* Normalize incoming markup into the standard internal structure and return it
   Accepts <ul class="module-marquee__track"> */
function normalizeTrack(rawTrack) {
	// Convert <ul class="module-marquee__track"> to div.module-marquee__track > ul.module-marquee__group
	const trackEl     = document.createElement("div");
	trackEl.className = "module-marquee__track";

	const group     = document.createElement("ul");
	group.className = "module-marquee__group";
	group.innerHTML = rawTrack.innerHTML; // keep original list items

	trackEl.appendChild(group);

	rawTrack.parentNode.replaceChild(trackEl, rawTrack);

	return {trackEl, baseGroupHTML: group.outerHTML};
}

/* Wait for images in container to load (resolves immediately if none) */
function waitForImages(container) {
	if (!container)
	{
		return Promise.resolve();
	}

	const imgs = Array.from(container.querySelectorAll("img"));
	if (!imgs.length)
	{
		return Promise.resolve();
	}

	return Promise.all(imgs.map(img => new Promise(resolve => {
		if (img.complete && img.naturalWidth !== 0)
		{
			return resolve();
		}
		img.onload = img.onerror = () => resolve();
	})));
}